import React from 'react';

// Utils
import { isElementOfType } from '../../utilities/components';

// Components
import WpBreadcrumbItem from './WpBreadcrumbItem';

// Styles
import './WpBreadcrumbs.scss';

type Props = {
  children: React.ReactNode;
};

const WpBreadcrumbs: React.FC<Props> = ({ children }: Props) => {
  const baseClassName = 'WpBreadcrumbs';

  return (
    <div className={baseClassName}>
      {React.Children.map(children, (child: React.ReactElement<any>) => {
        if (child && isElementOfType(child, WpBreadcrumbItem)) {
          return <div className={`${baseClassName}__item`}>{React.cloneElement(child)}</div>;
        }
      })}
    </div>
  );
};

export default WpBreadcrumbs;
